import { LitElement, html, css, type CSSResultGroup, type TemplateResult, PropertyValues } from "lit";
import { customElement, property } from "lit/decorators.js";
import { addGlobalStylesToShadowRoot } from "../../util/globalStyleSheetsUtil.js";
import {format} from "../../util/stringUtils.js";

@customElement("ehm-highcostcalc")
export class HighCostCalc extends LitElement {  
  private discount0: number;
  private discounts: DiscountType[];
  private resultstring: string;
  private freecardstring: string;
  private fullpricestring: string;
  private label: string;
  constructor() {
    super();
    this.discount0 = parseFloat(this.getAttribute("data-discount0") ?? "0");
    this.discounts = JSON.parse(this.getAttribute("data-discounts") ?? "");
    this.resultstring = this.getAttribute("data-resultstring") ?? "";
    this.freecardstring = this.getAttribute("data-freecardstring") ?? "";
    this.fullpricestring = this.getAttribute("data-fullpricestring") ?? "";
    this.label = this.getAttribute("data-label") ?? "";
  }
  firstUpdated(_changedProperties: PropertyValues): void {
    super.firstUpdated(_changedProperties);
    addGlobalStylesToShadowRoot(this.shadowRoot!);
    
  }

  private highCostRangeUtilUpdate = (event : InputEvent) => {
    const outControl = this.shadowRoot?.getElementById("high-cost-gross") as HTMLInputElement,
        inControl = this.shadowRoot?.getElementById("high-cost-control") as HTMLInputElement,
        rangeControl = this.shadowRoot?.getElementById("range-control-cost"),
        calculatedControl = document.getElementById("high-cost-calculated"),
        bargainControl = document.getElementById("high-cost-bargain"),
        customerMessage = document.getElementById("range-control-step");
    const sliderElement = event.target as HTMLInputElement;
    const sliderValue = parseInt(sliderElement.value);
    inControl.setAttribute("value", sliderValue.toString());
    outControl.setAttribute("value", sliderValue.toString());
    const progress = sliderValue / parseInt(inControl.max)*100;
    inControl.style.background = `linear-gradient(to right, var(--border-brand) ${progress}%, #ccc ${progress}%)`;
    const amount = parseInt(sliderElement.value);
    
    if (!this.discounts || this.discounts.length < 1 || outControl === null || inControl === null || calculatedControl === null || bargainControl === null || rangeControl === null || customerMessage === null) {
        return;
    }
       let costumerPayPercent = 100;

    outControl.value = amount.toString();
    inControl.value = amount.toString();

    if (amount <= this.discount0) {
        costumerPayPercent = 100 * 0.01;

        calculatedControl.innerHTML = (amount || 0).toString();
        bargainControl.innerHTML = "0";

        customerMessage.classList = "high-cost-calc__resultbox high-cost-calc__resultbox--0 heading-xs-bold"
        customerMessage.innerHTML = format(this.fullpricestring, this.discount0)
    }
    
    if (amount > this.discount0 && amount <= this.discounts[0].value) {
        costumerPayPercent = (100-this.discounts[0].percentage) * 0.01;

        calculatedControl.innerHTML = (
            this.discount0 +
            costumerPayPercent * (amount - this.discount0)
        ).toFixed();
        bargainControl.innerHTML = (amount - parseFloat(calculatedControl.innerHTML)).toString();

        customerMessage.classList = "high-cost-calc__resultbox high-cost-calc__resultbox--1 heading-xs-bold"
        customerMessage.innerHTML = format(this.resultstring, this.discounts[0].percentage, this.discount0+1, this.discounts[0].value)
    }
    for (let i = 0; i < this.discounts.length; i++) {
        if (i < this.discounts.length - 1 && amount > this.discounts[i].value && amount <= this.discounts[i + 1].value) {
            costumerPayPercent = (100-this.discounts[i + 1].percentage) * 0.01;

            let calculate = this.discount0;
            calculate += (this.discounts[0].value - this.discount0) * (100-this.discounts[0].percentage) * 0.01;
            for (let j = 0; j < i; j++) {+1
                calculate += (this.discounts[j + 1].value - this.discounts[j].value) * (100-this.discounts[j + 1].percentage) * 0.01;
            }

            calculatedControl.innerHTML = (
                calculate +
                costumerPayPercent * (amount - this.discounts[i].value)
            ).toFixed();
            bargainControl.innerHTML = (
                amount - parseFloat(calculatedControl.innerHTML)
            ).toFixed();

            customerMessage.classList = "heading-xs-bold high-cost-calc__resultbox high-cost-calc__resultbox--"+(i+2)
            customerMessage.innerHTML = format(this.resultstring, this.discounts[i + 1].percentage, this.discounts[i].value + 1, this.discounts[i+1].value)
        }
        else if (i == this.discounts.length - 1) {
            if (amount > this.discounts[i].value) {
                costumerPayPercent = 0;
                let calculate = this.discount0;
                calculate += (this.discounts[0].value - this.discount0) * (100-this.discounts[0].percentage) * 0.01;
                for (let j = 0; j < i; j++) {
                    calculate += (this.discounts[j + 1].value - this.discounts[j].value) * (100-this.discounts[j + 1].percentage) * 0.01;
                }
                
                calculatedControl.innerHTML = (
                    calculate
                ).toFixed();
                bargainControl.innerHTML = (
                    amount - parseFloat(calculatedControl.innerHTML)
                ).toFixed();

                customerMessage.classList = "heading-xs-bold high-cost-calc__resultbox high-cost-calc__resultbox--"+(i+2)
                customerMessage.innerHTML = format(this.freecardstring, this.discounts[i].value)
            }
        }
    }
}

  static styles: CSSResultGroup = [
    css`
      :host {
      #high-cost-gross{
      width: 135px;
      height: 2rem;
      border-radius: var(--radius-md);
      border: 1px solid var(--border-brand);
      padding: 0.5rem 0.75rem 0.5rem 0.75rem;
      }
      }
    `,
  ];

  render(): TemplateResult {
    return html`
    <div class="high-cost-calc flex flex-column">
      <div class="flex flex-row justify-content-end align-items-center gap">

    <label for="high-cost-gross">
    ${this.label}
    </label>
    <div class="">
        <label>
            <input type="number" @input=${(e: InputEvent) => this.highCostRangeUtilUpdate(e)} id="high-cost-gross" class="d-inline form-control me-2" value="0"> <slot name="currency"></slot>
        </label>
    </div>
    <slot name="currency"></slot>
    </div>
    <div id="range-control-cost" class="">
    <div class="flex flex-row justify-content-center">
        <input type="range" role="slider" id="high-cost-control" @input=${this.highCostRangeUtilUpdate} class="slider-input" min="0" max="10000" value="0" aria-label="läkemedelskostnad">
    </div>
    
</div>
</div>
    `;
  }
}


